import { jsx as _jsx } from "react/jsx-runtime";
export default function HandIcon() {
  return /*#__PURE__*/_jsx("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("g", {
      id: "hand",
      children: /*#__PURE__*/_jsx("path", {
        id: "Vector",
        d: "M5.25 8.625V10.5M5.25 8.625V4.125C5.25 3.82663 5.36853 3.54048 5.5795 3.3295C5.79048 3.11853 6.07663 3 6.375 3C6.67337 3 6.95952 3.11853 7.1705 3.3295C7.38147 3.54048 7.5 3.82663 7.5 4.125M5.25 8.625C5.25 8.32663 5.13147 8.04048 4.9205 7.8295C4.70952 7.61853 4.42337 7.5 4.125 7.5C3.82663 7.5 3.54048 7.61853 3.3295 7.8295C3.11853 8.04048 3 8.32663 3 8.625V10.125C3 11.6168 3.59263 13.0476 4.64752 14.1025C5.70242 15.1574 7.13316 15.75 8.625 15.75C10.1168 15.75 11.5476 15.1574 12.6025 14.1025C13.6574 13.0476 14.25 11.6168 14.25 10.125V6.375C14.25 6.07663 14.1315 5.79048 13.9205 5.5795C13.7095 5.36853 13.4234 5.25 13.125 5.25C12.8266 5.25 12.5405 5.36853 12.3295 5.5795C12.1185 5.79048 12 6.07663 12 6.375M7.5 4.125V8.25M7.5 4.125V3.375C7.5 3.07663 7.61853 2.79048 7.8295 2.5795C8.04048 2.36853 8.32663 2.25 8.625 2.25C8.92337 2.25 9.20952 2.36853 9.4205 2.5795C9.63147 2.79048 9.75 3.07663 9.75 3.375V4.125M12 6.375V4.125C12 3.82663 11.8815 3.54048 11.6705 3.3295C11.4595 3.11853 11.1734 3 10.875 3C10.5766 3 10.2905 3.11853 10.0795 3.3295C9.86853 3.54048 9.75 3.82663 9.75 4.125M12 6.375V8.25M9.75 4.125V8.25",
        stroke: "#E02424",
        strokeWidth: "1.6",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    })
  });
}